<template>
  <div v-if="product" class="rounded-2xl border border-[#e2e8f0] bg-white overflow-hidden shadow-sm">
    <div class="flex items-stretch">
      <!-- Photo (falls back to the product icon like ProductDetailView does) -->
      <div class="w-24 flex-shrink-0 bg-[#f8fafc] flex items-center justify-center p-2 border-e border-[#e2e8f0]">
        <img v-show="!imgFailed" :src="photoSrc" :alt="name" class="max-h-20 object-contain" @error="imgFailed = true" />
        <div v-show="imgFailed" class="w-12 h-12 rounded-xl bg-[var(--color-primary-light)] flex items-center justify-center text-[var(--color-primary)]">
          <component :is="icon" class="w-6 h-6" />
        </div>
      </div>
      <!-- Text -->
      <div class="flex-1 min-w-0 p-3">
        <h4 class="font-semibold text-[#2d3748] text-sm leading-snug truncate">{{ name }}</h4>
        <p class="text-[var(--color-primary)] text-xs mb-2 truncate">{{ subtitle }}</p>
        <button
          type="button"
          @click="goToProduct"
          class="inline-flex items-center gap-1 text-xs font-medium text-[var(--color-primary)] hover:text-[var(--color-primary-dark)] transition-colors"
        >
          {{ $t('chat_view_product') }}
          <ChevronRight class="w-3.5 h-3.5 rtl:rotate-180" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ChevronRight, Droplets, Waves, Gauge, ArrowDownCircle, Zap, Home } from 'lucide-vue-next'
import { productsData } from '../../data/products'

const props = defineProps({
  productId: { type: String, required: true }
})

const router = useRouter()
const { locale } = useI18n()

const iconMap = { droplets: Droplets, waves: Waves, gauge: Gauge, 'arrow-down-circle': ArrowDownCircle, zap: Zap, home: Home }

const product = computed(() => productsData.find((p) => p.id === props.productId))
const name = computed(() => product.value ? (product.value.name[locale.value] || product.value.name.en) : '')
const subtitle = computed(() => product.value ? (product.value.subtitle[locale.value] || product.value.subtitle.en) : '')
const icon = computed(() => (product.value && iconMap[product.value.icon]) || Droplets)
const photoSrc = computed(() => `${process.env.BASE_URL}images/fittings/${props.productId}/photo/Coupling.png`)

const imgFailed = ref(false)

function goToProduct() {
  router.push('/products/' + props.productId)
}
</script>
